import React from 'react';
export const FaqSection = () => {
  return <section style={{
    backgroundColor: '#e9f0f3'
  }} className="p-6 mb-10" data-id="element-74">
      <h2 className="text-4xl font-bold mb-6" style={{
      color: '#465866'
    }} data-id="element-75">
        "But Will It Really Work for My Dog?"
      </h2>
      <p className="text-xl mb-6 italic" data-id="element-76">
        "I understand the skepticism. As a vet, I was skeptical too. Here's what
        I tell concerned pet owners:
      </p>
      <h3 className="text-3xl font-bold text-gray-800 mb-4" data-id="element-77">
        Common Concerns I Hear:
      </h3>
      <div className="mb-6" data-id="element-78">
        <p className="text-xl font-bold mb-2" data-id="element-79">'My dog hates wearing things'</p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-80">
          <li className="mb-1" data-id="element-81">
            PawEase is designed for comfort, not restriction
          </li>
          <li className="mb-1" data-id="element-82">
            Most dogs accept it within minutes (unlike bulky alternatives)
          </li>
          <li className="mb-1" data-id="element-83">
            The calming effect often overrides initial resistance
          </li>
        </ul>
      </div>
      <div className="mb-6" data-id="element-84">
        <p className="text-xl font-bold mb-2" data-id="element-85">
          'We've tried vests before - they didn't work'
        </p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-86">
          <li className="mb-1" data-id="element-87">
            Most anxiety vests apply pressure incorrectly
          </li>
          <li className="mb-1" data-id="element-88">
            PawEase uses veterinary-designed pressure points
          </li>
          <li className="mb-1" data-id="element-89">
            It's the difference between a tight squeeze and therapeutic
            compression
          </li>
        </ul>
      </div>
      <div className="mb-6" data-id="element-90">
        <p className="text-xl font-bold mb-2" data-id="element-91">
          'What if my dog's anxiety is too severe?'
        </p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-92">
          <li className="mb-1" data-id="element-93">
            I've seen this work for dogs who've failed multiple medications
          </li>
          <li className="mb-1" data-id="element-94">
            Can be used alongside other therapies if needed
          </li>
          <li className="mb-1" data-id="element-95">Safe to try even with severe cases</li>
        </ul>
      </div>
      <div className="mb-6" data-id="element-96">
        <p className="text-xl font-bold mb-2" data-id="element-97">
          'How is this different from other anxiety shirts?'
        </p>
        <ul className="list-disc pl-6 mb-4 text-xl" data-id="element-98">
          <li className="mb-1" data-id="element-99">Designed by veterinarians, not marketers</li>
          <li className="mb-1" data-id="element-100">
            Targets specific pressure points based on canine anatomy
          </li>
          <li className="mb-1" data-id="element-101">Superior materials and construction</li>
        </ul>
      </div>
      <div className="w-full h-[300px] bg-gray-200 mb-6 overflow-hidden" data-id="element-102">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/ifcDt6scDCkb3jQsDDa8jk/Screenshot_2025-07-09_152221.png" alt="Two Labrador dogs wearing PawEase anxiety vests in olive green" className="w-full h-full object-contain" data-id="element-103" />
      </div>
      <h3 className="text-3xl font-bold text-gray-800 mb-2" data-id="element-104">
        My Professional Recommendation:
      </h3>
      <p className="text-xl mb-4 italic" data-id="element-105">
        'If I wouldn't give it to Bailey, I wouldn't recommend it to your dog.
        This isn't about selling a product - it's about giving dogs their lives
        back without compromising their health.'"
      </p>
    </section>;
};